<template>
  <div>
    <v-data-table
      class="invoicingTable vtable-scroll-x"
      hide-default-footer
      show-expand
      mobile-breakpoint="0"
      :expanded.sync="expanded"
      :items-per-page="invoicingFilter.size"
      :footer-props="{
        'items-per-page-text': 'Linhas por página',
        'first-icon': 'mdi-chevron-up',
        'page-text': '',
        'items-per-page-options': [10, 25, 50, 100],
      }"
      :headers="headers"
      :height="invoicingTableHeight"
      :items="hrProtectedInvoices"
      :page="invoicingFilter.page"
      :server-items-length="invoicesTotalElements"
      show-select
      v-model="selecteds"
    >
      <template v-for="header in defaultHeaderColumns" v-slot:[`header.${header.id}`]="{}">
        <HeaderCell :key="header.id" :id="header.id" :title="header.title" :headerClass="headerFirstLineClass" :headerStyle="headerFirstLine.style" />
      </template>

      <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
        <v-checkbox :value="isSelected" :indeterminate="isItemIndeterminate(item)" @change="select($event)" @click.stop hide-details class="my-0 py-0"></v-checkbox>
      </template>

      <template v-slot:[`item.data-table-expand`]="{ item, isExpanded, expand }">
        <v-icon v-if="canExpand(item)" @click.stop="expand(!isExpanded)" class="mr-2">
          {{ isExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
        </v-icon>
      </template>

      <template v-for="column in defaultStyleColumns" v-slot:[`item.${column}`]="{ item }">
        <Cell :key="column" :id="column" :content="item[column]" :cellClass="column" />
      </template>

      <template v-slot:[`item.downloads`]="{ item }">
        <span>{{
          item.downloads && item.downloads.length
            ? item.downloads.length > 1
              ? `${item.downloads.length}
          Arquivos`
              : `${item.downloads.length} Arquivo`
            : "0 Arquivos"
        }}</span>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td v-for="header in headers" :key="header.value" class="py-0" :class="{ 'px-0 text-center': header.value === 'data-table-select' }" style="vertical-align: top">
          <div v-if="header.value === 'data-table-select'">
            <div v-if="item.downloads && item.downloads.length" class="d-flex flex-column align-center justify-start">
              <div v-for="att in item.downloads" :key="att.fileName" class="d-flex align-center justify-center expanded-list-item-wrapper">
                <div style="width: 53px" class="d-flex justify-end">
                  <div style="width: 34px">
                    <v-checkbox :input-value="isDownloadSelected(att)" @change="toggleDownload(att, item)" @click.stop hide-details class="ma-0 pa-0"></v-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="header.value === 'downloads'">
            <div v-if="item.downloads && item.downloads.length">
              <v-list dense class="py-0 expanded-list-inside-table">
                <v-list-item v-for="att in item.downloads" :key="att.fileName" class="px-0 expanded-list-item-wrapper">
                  <v-list-item-content class="py-1">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-on="on" v-bind="attrs" class="d-inline-block fileToDownload truncate" @click="downloadFile(att.fileId)">
                          {{ att.fileName }}
                        </span>
                      </template>
                      <span
                        >Último download:
                        {{
                          `${att.userName}
                        ${formatter.formatDateTimeZoneWithHours(att.downloadDate)}` || ""
                        }}</span
                      >
                    </v-tooltip>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
            <div v-else class="caption grey--text">Sem anexos</div>
          </div>
        </td>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn color="primary" dark icon @click="openHistoryModal(item.id)">
          <v-icon> mdi mdi-clipboard-text-clock-outline </v-icon>
        </v-btn>
      </template>

      <template v-slot:footer="{ props }">
        <v-container fluid class="px-0 pt-0">
          <v-divider />
          <v-row justify="end" class="d-flex flex-row align-center fill-height px-8 pt-2" style="height: 70px">
            <div class="d-flex flex-row align-center fill-height">
              <span style="margin-right: 50px" :class="labelFooter.class" :style="labelFooter.style"> Linhas por página </span>

              <v-select :value="invoicingFilter.size" :items="props.itemsPerPageOptions" hide-details dense class="footerSelectItemsPerPage primary--text mt-0" color="primary" :style="selectFooter.style" append-icon="mdi-chevron-down" @change="setSize" />
            </div>

            <span v-if="invoicesTotalElements" :class="labelFooter.class" :style="labelFooter.style">
              {{ rangePagination }}
            </span>

            <v-btn icon :disabled="invoicingFilter.page === 0" @click="setInvoicingFilter({ page: invoicingFilter.page - 1 })">
              <v-icon size="24" color="primary"> mdi-chevron-left </v-icon>
            </v-btn>

            <v-btn icon :disabled="(invoicingFilter.page + 1) * props.pagination.itemsPerPage >= props.pagination.itemsLength" @click="setInvoicingFilter({ page: invoicingFilter.page + 1 })">
              <v-icon size="24" color="primary"> mdi-chevron-right </v-icon>
            </v-btn>
          </v-row>
        </v-container>
      </template>
    </v-data-table>
    <DownloadHistoryModal />
  </div>
</template>

<script>
import TodoListActions from "../../../TodoList/TodoListActions.vue";
import HeaderCell from "../HeaderCell.vue";
import Cell from "../Cell.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

import MovementRecordsMixin from "@/shared/mixins/movementRecords/movementRecordsMixin";
import InsuranceCarriersMixin from "@/shared/mixins/sdi/insuranceCarriersMixin";
import FinancialGroupsMixin from "@/shared/mixins/sdi/financialGroupsMixin";
import InvoicingMixin from "@/shared/mixins/invoicing/invoicingMixin";
import ContractsMixin from "@/shared/mixins/sdi/contractsMixin";
import InvoicingRules from "../../rules/invoicingRules.js";

import Formatters from "@/shared/formatters/formatters";
import DownloadHistoryModal from "./DownloadHistoryModal.vue";

export default {
  name: "InvoicingHrProtectedTable",

  components: {
    DownloadHistoryModal,
    TodoListActions,
    HeaderCell,
    Cell,
  },

  data: () => ({
    formatter: null,
    expanded: [],
    selecteds: [],
    selectedFiles: [],
    defaultHeaderColumns: [
      { id: "contract", title: "Contrato" },
      { id: "subcontract", title: "Subcontrato" },
      { id: "cnpj", title: "CNPJ" },
      { id: "carrierName", title: "Operadora" },
      { id: "benefitType", title: "Beneficío" },
      { id: "invoiceType", title: "Tipo" },
      { id: "competencyDate", title: "Competência" },
      { id: "limitDate", title: "Vencimento" },
      { id: "value", title: "Valor" },
      { id: "numberLives", title: "Vidas" },
      { id: "downloads", title: "Anexos" },
      { id: "actions", title: "Histórico de downloads" },
    ],
    selectedInvoicingId: null,
  }),

  mixins: [InsuranceCarriersMixin, MovementRecordsMixin, FinancialGroupsMixin, ContractsMixin, InvoicingRules, InvoicingMixin],

  watch: {
    selecteds(newSelectedItems, oldSelectedItems) {
      const added = newSelectedItems.filter((item) => !oldSelectedItems.includes(item));
      added.forEach((item) => {
        if (item.downloads && item.downloads.length) {
          item.downloads.forEach((att) => {
            if (!this.isDownloadSelected(att)) {
              this.selectedFiles.push(att);
            }
          });
        }
      });

      const removed = oldSelectedItems.filter((item) => !newSelectedItems.includes(item));
      removed.forEach((item) => {
        if (item.downloads && item.downloads.length) {
          const fileIdsToRemove = item.downloads.map((d) => d.fileId);
          this.selectedFiles = this.selectedFiles.filter((att) => !fileIdsToRemove.includes(att.fileId));
        }
      });
      this.$emit("selectedFiles", this.selectedFiles);
    },
  },

  methods: {
    ...mapActions({
      setInvoicingFilter: "invoicing/setInvoicingFilter",
    }),

    ...mapMutations({
      setShowDownloadHistoryModal: "invoicing/setShowDownloadHistoryModal",
    }),

    isDownloadSelected(att) {
      return this.selectedFiles.some((d) => d.fileId === att.fileId);
    },

    isItemIndeterminate(item) {
      if (!item.downloads || item.downloads.length === 0) {
        return false;
      }

      const totalDownloads = item.downloads.length;
      const selectedCount = item.downloads.filter((att) => this.isDownloadSelected(att)).length;

      return selectedCount > 0 && selectedCount < totalDownloads;
    },

    toggleDownload(att, item) {
      const isSelected = this.isDownloadSelected(att);
      if (isSelected) {
        this.selectedFiles = this.selectedFiles.filter((d) => d.fileId !== att.fileId);
      } else {
        this.selectedFiles.push(att);
      }
      this.updateParentSelection(item);
    },

    updateParentSelection(item) {
      if (!item.downloads || item.downloads.length === 0) return;

      const totalDownloads = item.downloads.length;
      const selectedCount = item.downloads.filter((att) => this.isDownloadSelected(att)).length;

      const isParentSelected = this.selecteds.includes(item);

      if (selectedCount === totalDownloads && !isParentSelected) {
        this.selecteds.push(item);
      } else if (selectedCount < totalDownloads && isParentSelected) {
        const index = this.selecteds.indexOf(item);
        if (index > -1) {
          this.selecteds.splice(index, 1);
        }
      }
    },

    canExpand(item) {
      return item.downloads && item.downloads.length > 0;
    },
    onRowClick(item) {
      if (!this.canExpand(item)) return;
      const idx = this.expanded.findIndex((e) => e === item || e.id === item.id);
      if (idx > -1) {
        this.expanded.splice(idx, 1);
      } else {
        this.expanded.push(item);
      }
    },

    setSize(size) {
      this.setInvoicingFilter({ size: size, page: 0 });
    },

    openHistoryModal(invoicingId) {
      this.selectedInvoicingId = invoicingId;
      this.setShowDownloadHistoryModal(true);
    },
    downloadFile(fileId) {
      console.log(fileId);
    },
  },

  computed: {
    ...mapGetters({
      invoicesTotalElements: "invoicing/invoicesTotalElements",
      invoicesTotalPages: "invoicing/invoicesTotalPages",
      invoicingFilter: "invoicing/invoicingFilter",
      isRHProtegido: "user-info/isRHProtegido",
      invoices: "invoicing/invoices",
    }),

    defaultStyleColumns() {
      return this.headers.filter((header) => !["downloads", "actions", "data-table-select", "data-table-expand"].includes(header.value)).map((header) => header.value);
    },

    hrProtectedInvoices() {
      return this.getInvoicesToHrProtected(this.invoices);
    },

    rangePagination() {
      const page = this.invoicingFilter.page;
      const size = this.invoicingFilter.size;
      const total = this.invoicesTotalElements;

      const start = total === 0 ? 0 : page * size + 1;
      const end = Math.min((page + 1) * size, total);

      return `${start}–${end} de ${total}`;
    },

    invoicingTableHeight() {
      const viewportHeight = window.innerHeight;
      const tableHeight = -560 + viewportHeight;
      const isFullScreen = tableHeight <= 1080;
      const hasMoreThanTen = this.hrProtectedInvoices && this.hrProtectedInvoices.length >= 10;

      if (!hasMoreThanTen) return null;
      if (!isFullScreen) return 455;
      return tableHeight < 400 ? 400 : tableHeight;
    },

    headers() {
      const xippPlatformClass = this.$vuetify.breakpoint.mdAndDown ? { class: "platformXippTable" } : {};
      return [
        { value: "contract", sortable: false, class: "col-w-250", cellClass: "col-w-250", ...xippPlatformClass },
        { value: "subcontract", sortable: false, class: "col-w-250", cellClass: "col-w-250", ...xippPlatformClass },
        { value: "cnpj", sortable: false, class: "col-w-200", cellClass: "col-w-200", ...xippPlatformClass },
        { value: "carrierName", sortable: false, class: "col-w-150", cellClass: "col-w-150", ...xippPlatformClass },
        { value: "benefitType", sortable: false, class: "col-w-100", cellClass: "col-w-100", ...xippPlatformClass },
        { value: "invoiceType", sortable: false, class: "col-w-100", cellClass: "col-w-100", ...xippPlatformClass },
        { value: "competencyDate", sortable: false, class: "col-w-100", cellClass: "col-w-100", ...xippPlatformClass },
        { value: "limitDate", sortable: false, class: "col-w-150", cellClass: "col-w-150", ...xippPlatformClass },
        { value: "value", sortable: false, class: "col-w-150", cellClass: "col-w-150", ...xippPlatformClass },
        { value: "numberLives", sortable: false, class: "col-w-100", cellClass: "col-w-100", ...xippPlatformClass },
        { value: "downloads", sortable: false, class: "col-w-150", cellClass: "col-w-150", ...xippPlatformClass },
        { value: "actions", width: "60px", sortable: false, align: "center", class: "col-w-150", cellClass: "col-w-150" },
      ];
    },

    headerFirstLineClass() {
      return this.$vuetify.breakpoint.mdAndDown ? `${this.headerFirstLine.class} platformXippTable` : this.headerFirstLine.class;
    },
  },

  created() {
    this.formatter = new Formatters();
  },

  async mounted() {
    await this.loadKinships();
  },
};
</script>

<style lang="scss">
.fileToDownload {
  text-decoration: none;
  color: #00a09d;
}

.fileToDownload:hover {
  cursor: pointer;
  text-decoration: underline;
}

.invoicingTable .col-w-250 {
  min-width: 250px !important;
  max-width: 250px !important;
}

.invoicingTable .col-w-200 {
  min-width: 200px !important;
  max-width: 200px !important;
}

.invoicingTable .col-w-150 {
  min-width: 150px !important;
  max-width: 150px !important;
}

.invoicingTable .col-w-100 {
  min-width: 100px !important;
  max-width: 100px !important;
}

.invoicingTable {
  border-radius: 5px !important;
  box-shadow: 0px 2px 6px #1a1f2626 !important;

  > .v-data-table__wrapper {
    border-radius: 5px 5px 0px 0px !important;

    > table {
      > .v-data-table-header {
        border-radius: 5px 5px 0px 0px !important;
        background-color: var(--v-ternary-base) !important;

        > tr {
          max-height: 90px;
          border-radius: 5px !important;

          > th {
            padding: 0 1% !important;
            background: var(--v-ternary-base) !important;

            > span {
              color: white !important;
            }
          }
        }
      }

      > tbody > tr {
        max-height: 70px;

        > td {
          padding: 0 1% !important;
        }
      }
    }
  }
}

.footerSelectItemsPerPage .v-select__selections {
  > .select__selection {
    margin: 5px 0x 3px 0 !important;
  }

  > input {
    display: none !important;
  }
}

.footerSelectItemsPerPage .v-select__selections {
  display: flex;
  justify-content: center;

  > .v-select__selection.v-select__selection--comma {
    margin: 5px 0px 3px 0 !important;
  }
}

.v-data-table > .v-data-table__wrapper tr.v-data-table__expanded {
  box-shadow: none !important;
}

.v-data-table__expanded__content > tr > td {
  padding: 0 !important;
}

.expanded-list-item-wrapper {
  min-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
}

.expanded-list-inside-table {
  background-color: transparent !important;
}

.cellContent {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cellLine {
  min-height: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.truncate {
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
